import { render, staticRenderFns } from "./industrialStag.vue?vue&type=template&id=decdb1c0&scoped=true"
import script from "./industrialStag.vue?vue&type=script&lang=js"
export * from "./industrialStag.vue?vue&type=script&lang=js"
import style0 from "./industrialStag.vue?vue&type=style&index=0&id=decdb1c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "decdb1c0",
  null
  
)

export default component.exports